import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/ad-spy-tool",
  adInfo: "/ad-spy-tool/:slug/:pageId",
};
